import { FC, useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// Phones have no built-in PDF viewer, so <object> shows its fallback even when the PDF exists.
// pdfViewerEnabled also catches Android Chrome in "Desktop site" mode, whose UA looks like desktop Linux.
export const needsInlinePdf = typeof navigator !== 'undefined'
  && ((navigator as any).pdfViewerEnabled === false || /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent));

/** Draws the PDF's pages at the box width; fetched via the backend since the S3 bucket has no CORS. */
const InlinePdfPages: FC<{ url: string }> = ({ url }) => {
  const boxRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);
  const [numPages, setNumPages] = useState(0);

  useEffect(() => setWidth(boxRef.current?.clientWidth || 0), []);

  return (
    <Box ref={boxRef} sx={{ flex: 1, width: '100%', overflowY: 'auto' }}>
      {width > 0 && (
        <Document file={`${process.env.REACT_APP_API_BASE_URL}/api/v1/invoice/pdf-file?url=${encodeURIComponent(url)}`}
          onLoadSuccess={({ numPages: n }) => setNumPages(n)}>
          {Array.from({ length: numPages }, (_, i) => (
            <Page key={i} pageNumber={i + 1} width={width} renderTextLayer={false} renderAnnotationLayer={false} />
          ))}
        </Document>
      )}
    </Box>
  );
};

export default InlinePdfPages;
